import { useEffect, useState } from "react";
import api, { isCanceled } from "../lib/api";

/**
 * Loads the sort-by dropdown options for a table.
 *
 * The list arrives either as JSON text or an already-parsed array depending on
 * the column type, and a malformed value used to throw straight out of the
 * `.then` and leave the page blank.
 */
export default function useSortOptions(name, notify) {
    const [sortBy, setSortBy] = useState([]);

    useEffect(() => {
        const controller = new AbortController();

        api.get('/options', { params: { name }, signal: controller.signal })
            .then((res) => {
                const data = res.data.data;
                let parsed = data;
                if (typeof data === "string") {
                    try {
                        parsed = JSON.parse(data);
                    } catch {
                        parsed = [];
                    }
                }
                setSortBy(Array.isArray(parsed) ? parsed : []);
            })
            .catch((err) => {
                if (isCanceled(err)) return;
                setSortBy([]);
                if (notify) notify.error(err, "Could not load sort options.");
            });

        return () => controller.abort();
    }, [name, notify]);

    return sortBy;
}
